import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";
import { ServiceProjectStatusEnum, zObjectId, zodPagination, zServiceProject } from "@dobrh-monorepo/core";

const requestSchema = z.object({
  // Filter by a single associate user
  associateId: zObjectId().optional(),
  status: z
    .union([z.nativeEnum(ServiceProjectStatusEnum), z.nativeEnum(ServiceProjectStatusEnum).array()])
    .optional(),
  searchText: z.string().optional(),
  ...zodPagination(),
});

const responseType = z.object({
  count: z.number(),
  list: z.array(zServiceProject),
  totalProjectsCount: z.number(),
  inProgressProjectsCount: z.number(),
  pendingProjectsCount: z.number(),
  overdueProjectsCount: z.number(),
  completeProjectsCount: z.number(),
});

export default {
  method: HttpMethodEnum.GET,
  paramsType: HttpParamsTypeEnum.QUERY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseType,
} satisfies Route;
